import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function Ticker() {
  const [quotes, setQuotes] = useState([]);

  useEffect(() => {
    let alive = true;
    const read = () =>
      api
        .get("/metals/ticker")
        .then((r) => {
          if (alive) setQuotes(r.data.quotes || []);
        })
        .catch(() => {});
    read();
    const id = setInterval(read, 10000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (!quotes.length) return null;

  return (
    <div className="border-t border-[#2A2E39] bg-[#0B0E14]">
      <div
        className="mx-auto flex max-w-[1500px] items-center gap-6 overflow-x-auto px-4 py-1.5 sm:px-6"
        data-testid="live-ticker"
      >
        <span className="flex shrink-0 items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#F0B90B]">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute h-full w-full animate-ping rounded-full bg-[#F0B90B] opacity-75" />
            <span className="h-1.5 w-1.5 rounded-full bg-[#F0B90B]" />
          </span>
          Live
        </span>
        {quotes.map((q) => {
          const up = q.change24hPercent === null || q.change24hPercent >= 0;
          return (
            <span key={q.symbol} data-testid={`ticker-${q.symbol.toLowerCase()}`} className="flex shrink-0 items-center gap-2">
              <span className="font-mono text-[11px] font-semibold text-[#848E9C]">{q.pair || `${q.symbol}/USD`}</span>
              <span className="font-mono text-xs font-bold text-[#EAECEF]">
                {q.price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
              <span
                className={`flex items-center gap-0.5 font-mono text-[11px] font-semibold ${
                  q.change24hPercent === null
                    ? "text-[#5E6673]"
                    : up
                    ? "text-[#0ECB81]"
                    : "text-[#F6465D]"
                }`}
              >
                {q.change24hPercent !== null &&
                  (up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />)}
                {q.change24hPercent === null
                  ? "—"
                  : `${up && q.change24hPercent !== 0 ? "+" : ""}${q.change24hPercent.toFixed(2)}%`}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
